import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @return {Promise<any>|Promise}
 */
export default (function () {
    var request = new Request({
        method: Methods.GET,
        url: EndPoints.REFRESH_TOKEN,
        withCredentials: true
    });
    return request.execute();
});
